import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;

  @media (max-width: 1000px) {
    display: block;
  }
`;
